import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/kaden.css";
import "./styles/admin-fixes.css";
import "./styles/toggles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
